import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import styles from './ComingSoonPage.module.scss';
import { IoArrowBack, IoHomeOutline, IoGiftOutline, IoArrowForward } from 'react-icons/io5';
import { toast } from 'react-toastify';

const ComingSoonPage = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (!email) return;
    // Giả lập gửi API
    toast.success("Đăng ký nhận tin thành công! Chúng tôi sẽ báo khi trang này hoàn tất.");
    setEmail('');
  };

  return (
    <div className={styles.pageContainer}>
      <div className={styles.contentWrapper}>
        
        {/* --- PHẦN HÌNH ẢNH MINH HỌA --- */}
        <div className={styles.illustration}>
            {/* Bạn có thể thay bằng ảnh GIF hoặc ảnh tĩnh phù hợp */}
            <div className={styles.iconCircle}>
               <IoGiftOutline />
            </div>
            <div className={styles.decorationCircle}></div>
        </div>

        {/* --- PHẦN NỘI DUNG --- */}
        <h1 className={styles.title}>Chúng Tôi Đang Hoàn Thiện</h1>
        <p className={styles.subtitle}>
          Trang này đang được <strong>Hương Trầm Cổ Mộc</strong> chăm chút và xây dựng để mang đến trải nghiệm tốt nhất cho bạn. 
          <br />Vui lòng quay lại sau ít ngày nữa nhé!
        </p>

        {/* Form đăng ký nhận tin (Giữ chân khách) */}
        <div className={styles.notifyBox}>
            <p>Nhận thông báo khi trang này sẵn sàng:</p>
            <form onSubmit={handleSubscribe} className={styles.subscribeForm}>
                <input 
                    type="email" 
                    placeholder="Nhập email của bạn..." 
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <button type="submit">
                    Gửi <IoArrowForward />
                </button>
            </form>
        </div>

        {/* Các nút điều hướng */}
        <div className={styles.actionButtons}>
          <button onClick={() => navigate(-1)} className={styles.btnSecondary}>
            <IoArrowBack /> Quay Lại
          </button>
          
          <Link to="/" className={styles.btnPrimary}>
            <IoHomeOutline /> Về Trang Chủ
          </Link>
          
          <Link to="/san-pham" className={styles.btnOutline}>
            Xem Sản Phẩm
          </Link>
        </div>

      </div>

      <div className={styles.footerText}>
         © {new Date().getFullYear()} Hương Trầm Cổ Mộc. Tinh hoa đất trời.
      </div>
    </div>
  );
};

export default ComingSoonPage;